(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('skeletonLabel', {
            templateUrl: 'app/components/skeleton/label/skeleton-label.html',
            controller: skeletonLabelController,
            bindings: {
                label: '@'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function skeletonLabelController() {
        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.label = vm.label || Math.random().toString(36).substring(10);
        }
    }
})();
